import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';

const PricingTeaser: React.FC = () => {
  const { t } = useTranslation('home');
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section className="py-20" ref={ref}>
      <div className="container-custom">
        <motion.div
          className="card p-12 text-center max-w-4xl mx-auto"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={inView ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6 gradient-text">
            {t('pricingTeaser.title')}
          </h2>
          <p className="text-xl text-secondary mb-8 max-w-2xl mx-auto">
            {t('pricingTeaser.subtitle')}
          </p>
          <Link to="/pricing" className="btn-primary">
            {t('pricingTeaser.cta')}
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default PricingTeaser;
